import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch, mapDropdown } from '@/utils'

export default {
  async getSchedulers(params) {
    try {
      const response = await axios.get('uni/schedules', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { records } = data.data
        const { total } = data.data
        return { records, total }
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async selectSchedulers(params) {
    try {
      const response = await axios.get('uni/schedules/selectSchedulers', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { records } = data.data
        const { total } = data.data
        return { records, total }
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getListSchedulers(params) {
    try {
      const response = await axios.get('uni/schedules/getSchedulers', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async createSchedule(dataObj) {
    try {
      const response = await axios.post('uni/schedules/createSchedule', dataObj)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async updateSchedule(dataObj) {
    try {
      const response = await axios.put('uni/schedules', dataObj)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async deleteScheduleByCreditClass(params) {
    try {
      const response = await axios.delete(`uni/schedules/${params.creditClassId}`, { params })
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async deleteScheduleByCreditClassAndRoomAndTeacher(item) {
    try {
      const response = await axios.delete(`uni/schedules/${item.creditClassId}/${item.roomId}/${item.teacherId}/${item.yearWeekId}/${item.checkRemoveAll}`)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getDays() {
    const response = await axios.get('uni/days/get_all_day')
    const { data } = response
    if (data.code === ApiCode.SUCCESS) {
      const records = data.data
      return mapDropdown(records)
    }
  },

  async getYearWeek(params) {
    const response = await axios.get('uni/course/semesters/get_week', { params })
    const { data } = response
    if (data.code === ApiCode.SUCCESS) {
      return data.data
    }
  },

  async getSchedulersV3(params) {
    try {
      const response = await axios.get('uni/schedules/getSchedulesV3', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { records, total } = data.data
        return { records, total }
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getTurns() {
    try {
      const response = await axios.get('uni/turns/get_all_turn')
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getCreditClassDetail(params) {
    try {
      // Expect params like { id: creditClassId } or other filters
      const response = await axios.get('uni/credit_classes/getById', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },

  async getCourseSemesters(params) {
    try {
      const response = await axios.get('uni/course/semesters', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { records } = data.data
        return records.map(item => ({
          value: item.id,
          label: item.status === 2 ? (`${item.name} - Đã học`) : (item.status === 1 ? (`${item.name} - Đang học`) : (`${item.name} - Chưa học`)),
          code: item.code ? item.code : null,
        }))
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },

  async getSchedulesWeekly(params) {
    try {
      const response = await axios.get('uni/schedules/getSchedulesWeekly', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { records, total } = data.data
        return { records, total }
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },

  async saveScheduleMatrix(dataObj) {
    try {
      const response = await axios.post('uni/schedules/saveScheduleMatrix', dataObj)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
  },

  async getTeachersCreditClass(params) {
    try {
      const response = await axios.get('uni/credit_class/teachers', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { records } = data.data
        return mapDropdown(records)
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },

  async getRoomsByCreditClass(params) {
    try {
      const response = await axios.get('uni/credit_class_rooms', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        const { records } = data.data
        return mapDropdown(records)
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },

  async exportScheduler(params) {
    try {
      const responseStudentInfo = await axios({
        method: 'get',
        url: 'uni/reports/reportScheduler',
        responseType: 'blob',
        params,
      })
      return responseStudentInfo.data
    } catch (e) {
      handleCatch(e)
    }
  },

  async importScheduler(data) {
    try {
      const response = await axios.post('uni/schedules/import', data)
      return response.data
    } catch (e) {
      handleCatch(e)
    }
  },
}
